import * as React from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";
import { SocialIcon } from 'react-social-icons';
import {
	Box,
	Container,
	Row,
	Column,
	FooterLink,
	Heading,
} from "./FooterStyles";

import mysy_logo2 from "../mysy_img2/Logo_MySy.png"


const Footer_v2 = () => {

	// Integration du gestionnaire de cookie : axeptio

	window.axeptioSettings = {
		clientId: "6273ecd99c50de9cfb190555",
		cookiesVersion: "mysy training technology-fr",
	};

	(function (d, s) {
		var t = d.getElementsByTagName(s)[0], e = d.createElement(s);

		e.async = true; e.src = "//static.axept.io/sdk-slim.js";
		t.parentNode.insertBefore(e, t);
	})(document, "script");


	return (
		<div className='footer_v2'>
			<div className='div_row' style={{ "minHeight": "15rem" }}>
				&nbsp;
			</div>

			<div className='div_row' >

				<div className='div_colonne_25' style={{ "textAlign": "left", "paddingLeft": "5%" }} >
					<div>
						<img src={mysy_logo2} alt="MySy Training Technology" />
						<nav className="training">TRAINING</nav>
					</div>
					<div className='text_sous_logo'>
						Le Guide des formations & Tutos pour tous Trouvez la formation ou le tuto selon vos critères
					</div>
				</div>
				<div className='div_colonne_25' >
					<div className='entete_txt'> MySy Training </div>
					<div className='a_link'>  A propos </div>
					<div className='a_link'> Nos engagements</div>
					<div className='a_link'> Nous contacter </div>
					<div className='a_link'> CGU </div>
					<div className='a_link'> CGV </div>

				</div>

				<div className='div_colonne_25' >
					<div className='entete_txt'> Prix </div>
					<div className='a_link'> Nos offres </div>
					<div className='a_link'> Publier votre catalogue</div>
					<div className='a_link'> M’inscrire</div>
					<div className='a_link'> Me connecter</div>
					<div className='a_link'> Données Personnelles</div>
					<div className='a_link'> Mentions légales</div>

				</div>

				<div className='div_colonne_25' >
					<div className='entete_txt'> Newsletters </div>
					<div className='block_newsletter'>
						Entrer votre email

					</div>

				</div>


			</div>

		</div>

	);
};
export default Footer_v2;
